import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { PoTableColumn } from "@po-ui/ng-components";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class OrcamentoPrintService {
  constructor(private http: HttpClient) {}

  urlCliente = `${environment.API}clientes`;
  urlProdutos = `${environment.API}produtos`;
  urlTransportadoras = `${environment.API}transportadoras`;
  urlPreco = `${environment.API}tabprc_1`;
  urlOrcamentos = `${environment.API}listaOrcamento`;
  urlcabOrcamento = `${environment.API}cabOrcamento`;
  urlItensOrcamento = `${environment.API}itensorcamento`;
  urlcondPagamentos = `${environment.API}condpagamentos`;
  urlVendedor = `${environment.API}users`;
  headers = new HttpHeaders({'authorization':sessionStorage.getItem("token")});
 

  getDadosClientes(cgc: string, segmto : string): Observable<any> {
    return this.http.post(this.urlCliente, {cgc: cgc , tiporeq: 'C', segmto: segmto},{headers: this.headers});
  }
  
  getCondPG(codigo): Observable<any> {
    return this.http.post(this.urlcondPagamentos, {codigo: codigo , tiporeq: 'C'},{headers: this.headers});
  }

  getVendedor(codigo): Observable<any> {
    return this.http.post(this.urlVendedor, {vendedor: codigo , tiporeq: 'UC'},{headers: this.headers});
  }
  

  getCabOrcamento(id: number): Observable<any> {
    return this.http.post(this.urlOrcamentos, {
      id: id,
    },{headers: this.headers});
  }

  getItensOrcamento(id: number): Observable<any> {
    return this.http.post(this.urlItensOrcamento, {
      id: id,
    },{headers: this.headers});
  }

}
